import axios from './axios';

// 取得所有分類
export function getAllCategories() {
    return axios.get('/api/category').then(res => res.data);
}

// 取得單一分類
export function getCategoryById(id) {
    return axios.get(`/api/category/${id}`).then(res => res.data);
}

// 新增分類
export function createCategory(category) {
    return axios.post('/api/category', category).then(res => res.data);
}

// 更新分類
export function updateCategory(id, category) {
    return axios.put(`/api/category/${id}`, category).then(res => res.data);
}

// 刪除分類
export function deleteCategory(id) {
    return axios.delete(`/api/category/${id}`).then(res => res.status === 200 || res.status === 204);
}
